import { gql } from '@material-bank/graphql-client'

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    currentUser {
      id
      email
      firstName
      lastName
      activeProjectId
      avatarUrl
      jobTitle
      phone
      organizationName
    }
  }
`
